import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiUsers, FiTarget, FiTrendingUp, FiAward, FiHeart, FiZap } from 'react-icons/fi';
import './AboutPage.css';

const AboutPage = () => {
  const values = [
    {
      icon: FiHeart,
      title: 'אותנטיות',
      description: 'אנו מאמינים בשיווק אותנטי שמחבר בין מותגים ליוצרים באופן אמיתי'
    },
    {
      icon: FiZap,
      title: 'חדשנות',
      description: 'שימוש בטכנולוגיית AI מתקדמת ליצירת התאמות מושלמות'
    },
    {
      icon: FiTarget,
      title: 'התמקדות',
      description: 'מיקוד בתוצאות עסקיות אמיתיות ולא רק במספרים'
    },
    {
      icon: FiUsers,
      title: 'קהילה',
      description: 'בניית קהילה חזקה של יוצרי תוכן ומותגים מובילים'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${process.env.PUBLIC_URL}/about-hero.png)` }}>
        <div className="container">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1>
              מובילים ברשת מאות לקוחות
              <br />עכשיו תורכם להצטרף
            </h1>
          </motion.div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section section">
        <div className="container">
          <div className="about-grid">
            <motion.div
              className="about-content"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2>מי אנחנו</h2>
              <p>
                <img src="/logo-white.png" alt="Weon" className="inline-logo-small" /> היא חברה ותיקה המשלבת בתוכה אנשי מקצוע בתחום המדיה עם ותק של 20 שנה בתחום הדיגיטל ועובדת עם משפיענים בעשור האחרון.
              </p>
              <p>
                הפעילות שלנו מאפשרת למותגים לקבל את היוצרים המתאימים ביותר לקמפיינים של המותג ובמקביל מעניקה ליוצרים הזדמנויות עבודה מגוונות עם מותגים מובילים בשוק הישראלי והבינלאומי.
              </p>
            </motion.div>
            <motion.div
              className="about-visual"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className="visual-shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section - with stats-section background */}
      <section className="stats-section" style={{ backgroundColor: '#f7941d' }}>
        <div className="container">
          <h2 className="section-title" style={{ color: '#fff', marginBottom: '40px' }}>הערכים שלנו</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <motion.div
                key={index}
                className="value-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="value-icon">
                  <value.icon />
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section why-us-section">
        <div className="container">
          <h2 className="section-title-dark">השירותים שלנו</h2>
          <div className="why-us-flow">
            <div className="why-us-item why-us-item--large">
              <span className="why-us-number">01</span>
              <h3>קמפיין משפיענים לכל תקציב</h3>
              <p>החל ממיקרו משפיענים המייצרים קמפיינים משולבים ומגיעים לחשיפה של עשרות ומאות אלפי צפיות. קמפיינים המתאימים גם לעסקים קטנים עם תקציב מוגדר ועד לחברות הגדולות במשק.</p>
            </div>
            <div className="why-us-item why-us-item--medium">
              <span className="why-us-number">02</span>
              <h3>נבחרת המשפיענים</h3>
              <p>הקמת קבוצה של משפיענים ומשפיעניות התואמות על פי קהל העוקבים שלהם לסוג המוצר, השירות וערכי המותג שלכם. בעזרתם ניצור שיווק וזיהוי מידי של המותג שלכם במדיה בפרט ובשוק בכלל.</p>
            </div>
            <div className="why-us-item why-us-item--medium">
              <span className="why-us-number">03</span>
              <h3>השקת מוצרים ומותגים</h3>
              <p>החלטתם להשיק מותג חדש/להציג מוצר חדש בחנות או ברשת אנו נגבה אתכם עם נבחרת משפיענים ומשפיעניות שיגיעו לאירוע ויעזרו למותג שלכם לקבל חשיפה חסרת תקדים.</p>
            </div>
            <div className="why-us-item why-us-item--small">
              <span className="why-us-number">04</span>
              <h3>הפקת תוכן</h3>
              <p>אם בעבר כדי לייצר תוכן איכותי היה צורך בהפקת ימי צילום ועריכה מפרכים אנו בעזרת המשפיענים והמשפיעניות שלנו שיבחרו בהתאם למותג, לשירות, למוצר שלכם. ניצור בעבורכם תוכן איכותי, קליט עם חשיפה גדולה במיוחד.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <motion.div
            className="cta-content"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>מוכנים להתחיל?</h2>
            <p>הצטרפו למהפכת השיווק המשפיענים החכם</p>
            <div className="cta-actions">
              <Link to="/register?type=brand" className="btn-brand">
                מותג? התחל קמפיין
              </Link>
              <Link to="/register?type=influencer" className="btn-influencer">
                הצטרפו כיוצרים
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
